import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const Captain = () => {
  return (
    <>
      <section className="header-sec">
        <nav className="navbar navbar-expand-lg all">
          <ul className="navbar-nav site mr-auto mt-2 mt-lg-0">
            <li className="nav-item">
              <Link className="nav-link" to="/patrons"><FormattedMessage id="page.nav-winds-patrons" /></Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/partner"><FormattedMessage id="page.nav-winds-partner" /></Link>
            </li>
            <li className="nav-item site-active">
              <Link className="nav-link" to="/digi-world"><FormattedMessage id="page.nav-winds-digi" /></Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about-us"><FormattedMessage id="page.nav-about-us" /></Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/luckydraw-patrons"><FormattedMessage id="page.nav-winds-luckydraw" /></Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/testimonials"><FormattedMessage id="page.nav-winds-testimonials" /></Link>
            </li>
          </ul>
        </nav>
      </section>
      <section className="about-sec-1 patrons bg site-page site-top">
        <div className="container font-proxima-nova">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex flex-column justify-content-center">
              <img className="w-50 mb-4 mb-md-3" src={require('../../../assets/img/site-captain/DigiWorldLogo.png')} alt="about" />
              <h1 className="title-captain"><FormattedMessage id="captain.section1.title" /></h1>
              <p className="desc"><FormattedMessage id="captain.section1.desc" /></p>
              <h2 className="mt-4 mb-3 download-patron"><FormattedMessage id="captain.section1.subtitle" /></h2>
              <div className="paystore">
                <a href="https://c.winds.to/app" target="blank">
                  <img src={require('../../../assets/img/site-patrons/ic_google_pay.png')} alt="icon" />
                </a>
                <a href="https://c.winds.to/app" target="blank">
                  <img src={require('../../../assets/img/site-patrons/ic_app_store.png')} alt="about" />
                </a>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 d-flex flex-column justify-content-center">
              <img className="px-md-5 px-0" width="100%" src={require('../../../assets/img/site-captain/ic_winds_captain.png')} alt="about" />
            </div>
          </div>
        </div>
      </section>
      <section className="about-sec-2captain site-page">
        <div className="container font-proxima-nova">
          <div className="row reverse-col">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex flex-column justify-content-center">
              <img width="100%" src={require('../../../assets/img/site-captain/ic_criteria.png')} alt="about" className="pr-md-5 pr-0 mt-md-0 mt-3" />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex flex-column justify-content-center">
              <h1 className="title-captain"><FormattedMessage id="captain.section2.title" /></h1>
              <p className="desc"><FormattedMessage id="captain.section2.desc1" /></p>
              <p className="desc"><FormattedMessage id="captain.section2.desc2" /></p>
            </div>
          </div>
        </div>
      </section>
      <section className="about-sec-3captain site-page">
        <div className="container font-proxima-nova">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 d-flex flex-column justify-content-center ">
              <h1 className="title-captain"><FormattedMessage id="captain.section3.title" /></h1>
              <p className="desc"><FormattedMessage id="captain.section3.desc1" /></p>
              <p className="desc"><FormattedMessage id="captain.section3.desc2" /></p>
              <p className="desc"><FormattedMessage id="captain.section3.desc3" /></p>
              <p className="desc"><FormattedMessage id="captain.section3.desc4" /> </p>
            </div>
            <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex flex-column justify-content-center align-items-center">
              <img src={require('../../../assets/img/site-captain/ic_responsibilities_mockup.png')} alt="about" className="px-0 px-md-5 mt-md-0 mt-3 w-100" />
            </div>
          </div>
        </div>
      </section>
      <section className="about-sec-4 site-page">
        <div className="container font-proxima-nova">
          <div className="row reverse-col">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex flex-column justify-content-center">
              <img width="100%" src={require('../../../assets/img/site-captain/digiworld_chart.jpg')} alt="about" className="pr-0 mt-md-0" />
              <h2 className="download-patron text-center"><FormattedMessage id="captain.section4.image-title" /></h2>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex flex-column justify-content-center">
              <h1 className="title-captain"><FormattedMessage id="captain.section4.title" /></h1>
              <p className="desc"><FormattedMessage id="captain.section4.desc1" /></p>
              <ol className="bullet">
                <li><FormattedMessage id="captain.section4.desc1a" /></li>
                <li><FormattedMessage id="captain.section4.desc1b" /></li>
              </ol>
              <p className="desc"><FormattedMessage id="captain.section4.desc2" /></p>
              <ol className="bullet">
                <li><FormattedMessage id="captain.section4.desc2a" /></li>
                <li><FormattedMessage id="captain.section4.desc2b" /></li>
              </ol>
              <p className="desc"><FormattedMessage id="captain.section4.desc3" /></p>
              <ol className="bullet">
                <li><FormattedMessage id="captain.section4.desc3a" /></li>
                <li><FormattedMessage id="captain.section4.desc3b" /></li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="site-page" style={{ background: "#FAF1E8" }}>
        <div className="container font-proxima-nova">
          <div className="row">
            <div className="col-12 d-flex flex-column justify-content-center">
              <h1 className="title-captain"><FormattedMessage id="captain.section5.title" /></h1>
              <div className="d-flex align-items-start">
                <img className="mr-2" src={require('../../../assets/img/site-captain/ic_tick_mark.png')} width="30px" alt="tick" />
                <p className="desc"><FormattedMessage id="captain.section5.desc1" /></p>
              </div>
              <div className="d-flex align-items-start">
                <img className="mr-2" src={require('../../../assets/img/site-captain/ic_tick_mark.png')} width="30px" alt="tick" />
                <p className="desc"><FormattedMessage id="captain.section5.desc2" /> </p>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-12 d-flex flex-column justify-content-center">
              <h1 className="title-captain"><FormattedMessage id="captain.section6.title" /></h1>
              <p className="desc"><FormattedMessage id="captain.section6.desc1" /></p>
              <p className="desc"><FormattedMessage id="captain.section6.desc2" /></p>
              <p className="desc"><FormattedMessage id="captain.section6.desc3" /></p>
              <h1 className="download-patron pt-3" style={{ textDecoration: "underline" }}>
                <Link to="/digi-world-faq">
                  <FormattedMessage id="captain.faq" />
                </Link>
              </h1>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Captain;
